import React, { Component } from 'react';
import scrollToElement from "scroll-to-element"

import "./HidaIframe.scss"
import { mobile } from '../Services/Agent';

class HidaIframe extends Component {
    constructor() {
        super();
        this.state = {
            iframeURL: "https://moinil.maps.arcgis.com/apps/webappviewer/index.html?id=9f051588efeb48288c7357da50d71ffb"
        }
        this.setIframe = this.setIframe.bind(this);
        this.scrollToIframe = this.scrollToIframe.bind(this);
    }
    componentDidMount() {
        this.setIframe();
        window.addEventListener("resize", this.setIframe);
    }
    setIframe() {
        this.setState({
            iframeURL: mobile() || window.document.body.clientWidth < 1000 ? "https://moinil.maps.arcgis.com/apps/webappviewer/index.html?id=9f051588efeb48288c7357da50d71ffb" : "https://moinil.maps.arcgis.com/apps/webappviewer/index.html?id=9f051588efeb48288c7357da50d71ffb"
        })
    }
    scrollToIframe() {
        scrollToElement('.fixheight', {
            offset: 0,
            ease: 'linear',
            duration: 1000
        });
    }
    render() {
        return (
            <section className="section section-hida">
                <div className="padding">
                    <div className="container">
                        <div className="button" onClick={this.scrollToIframe}></div>
                        <div className="fixheight">
                            <iframe title="" src={this.state.iframeURL} frameBorder="0" scrolling="0"></iframe>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default HidaIframe;



// WEBPACK FOOTER //
// ./src/Components/HidaIframe/HidaIframe_2.jsx